import {
  ContainerItem,
  VariantInputLabel,
  VerticalList,
} from "./BoardInventoryStyles";
import React from "react";

export default function BinInfo({
  binName,
  binLocation,
  binBarcode,
  binType,
  canAllocateFromBin,
  additionalKeyValuePairs,
  forTooltip,
}: {
  binName: string;
  binLocation: string;
  binBarcode: string;
  binType: string;
  canAllocateFromBin: boolean;
  additionalKeyValuePairs?: { [key: string]: string };
  forTooltip?: boolean;
}) {
  return (
    <VerticalList>
      <ContainerItem>
        <VariantInputLabel forTooltip={forTooltip || false}>
          Bin name:
        </VariantInputLabel>
        {binName}
      </ContainerItem>
      <ContainerItem>
        <VariantInputLabel forTooltip={forTooltip || false}>
          Bin location:
        </VariantInputLabel>
        {binLocation}
      </ContainerItem>
      <ContainerItem>
        <VariantInputLabel forTooltip={forTooltip || false}>
          Bin code:
        </VariantInputLabel>
        {binBarcode}
      </ContainerItem>
      <ContainerItem>
        <VariantInputLabel forTooltip={forTooltip || false}>
          Bin type:
        </VariantInputLabel>
        {binType}
      </ContainerItem>
      {!canAllocateFromBin && (
        <ContainerItem>
          <VariantInputLabel forTooltip={forTooltip || false}>
            Allocations cannot be made from containers in this bin.
          </VariantInputLabel>
        </ContainerItem>
      )}
      {additionalKeyValuePairs &&
        Object.entries(additionalKeyValuePairs).map(([key, value]) => {
          return (
            <ContainerItem key={key}>
              <VariantInputLabel forTooltip={forTooltip || false}>
                {key}
              </VariantInputLabel>
              {value}
            </ContainerItem>
          );
        })}
    </VerticalList>
  );
}
